import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { assertAdmin } from "./adminAuth.server";
import {
  HOME_BLOCK_OPACITY_KEY,
  normalizeHomeBlockOpacity,
  type HomeBlockOpacity,
} from "./homeBlockOpacity.server";

export type { HomeBlockOpacity };

const opacityValueSchema = z.object({
  mobile: z.number(),
  desktop: z.number(),
});

// نسمح بإرسال التنسيق القديم أو الجديد أثناء الانتقال
const opacityEntrySchema = z.union([z.number(), opacityValueSchema]);

export const getHomeBlockOpacity = createServerFn({ method: "GET" })
  .inputValidator((d: unknown) =>
    z.object({}).parse(d ?? {}),
  )
  .handler(async ({ data: input }) => {
  const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
  const { data } = await supabaseAdmin
    .from("app_settings")
    .select("value")
    .eq("key", HOME_BLOCK_OPACITY_KEY)
    .maybeSingle();
  return { opacity: normalizeHomeBlockOpacity(data?.value ?? null) };
});

export const setHomeBlockOpacity = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: unknown) =>
    z
      .object({
        opacity: z.record(z.string(), opacityEntrySchema),
      })
      .parse(d),
  )
  .handler(async ({ data, context }) => {
    await assertAdmin(context.userId);
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const value = normalizeHomeBlockOpacity(data.opacity);
    const { error } = await supabaseAdmin.from("app_settings").upsert(
      {
        key: HOME_BLOCK_OPACITY_KEY,
        value,
        updated_by: context.userId,
        updated_at: new Date().toISOString(),
      },
      { onConflict: "key" },
    );
    if (error) throw new Error(error.message);
    return { ok: true, opacity: value };
  });
